<template>
	<v-dropdown
		:ref="setup._popover"
		class="shared-company-flat-select"
		@apply-show="setup.handlePopoverShowAsync()"
		@apply-hide="setup.handlePopoverHide()">
		<slot>
			<div class="shared-company-flat-select__select">
				<div class="shared-company-flat-select__display">
					<o-button
						nude
						color="info">
						{{ $t('common.label.associateToCompany') }}
					</o-button>
				</div>
			</div>
		</slot>

		<template #popper>
			<o-button
				v-if="displayAddAll"
				v-tooltip="modelValue?.filter(x => !!x.membershipId).length === setup.companiesList.length
					? $t('business.companiesList.foundCompanies')
					: undefined"
				color="info"
				outline
				block
				:disabled="modelValue?.filter(x => !!x.membershipId).length === setup.companiesList.length"
				@click="setup.addAllCompaniesAsync()">
				{{ $t('common.label.linkAllCompanies') }}
			</o-button>

			<shared-flat-select
				v-if="setup.companiesList.length"
				v-model:search="setup.search"
				:show-search="setup.companies.length > 10"
				:loading="setup.loading"
				:value="modelValue"
				:selected-function="setup.companyIsSelected.bind(setup)"
				:options="setup.companiesListOptionsForFlatSelect"
				@add="setup.addCompanyAsync($event)"
				@delete="setup.deleteCompanyAsync($event)">
				<template #default="{ item: company }">
					<div
						v-if="company"
						class="shared-company-flat-select__item">
						<p
							class="shared-company-flat-select__item-name"
							v-html="company.name.mark(setup.search)"/>
						<p
							v-if="company.contactDetailCity"
							class="shared-company-flat-select__item-city"
							v-html="company.contactDetailCity.mark(setup.search)"/>
						<o-label
							v-if="setup.self.isClient()"
							outline>
							{{ company.agencyCompanyName }}
						</o-label>
					</div>
				</template>

				<template #empty>
					<o-alert
						color="info"
						center>
						{{ $t('admin.order.apiErrors.dashboard.noCompaniesYet') }}
					</o-alert>
				</template>
			</shared-flat-select>
		</template>
	</v-dropdown>
</template>

<script setup lang="ts">
// #region Setup
import type { SharedCompanyFlatSelectEmits, SharedCompanyFlatSelectProps } from './SharedCompanyFlatSelectSetup';
import SharedCompanyFlatSelectSetup from './SharedCompanyFlatSelectSetup';
const emits = defineEmits<SharedCompanyFlatSelectEmits>() as SharedCompanyFlatSelectEmits;
const props = withDefaults(defineProps<SharedCompanyFlatSelectProps>(), SharedCompanyFlatSelectSetup.defaultProps);
const setup = new SharedCompanyFlatSelectSetup(props, emits);
// #endregion
</script>

<style scoped lang="less">
.shared-company-flat-select {
	&__item-name {
		margin-bottom: unset;
		font-size: 0.8125rem;
		font-weight: 700;
		color: var(--grey-darker);
	}

	&__item-city {
		margin-bottom: unset;
		font-size: 0.8125rem;
		font-weight: 400;
		color: var(--grey-dark);

		+ .arm-label {
			margin-top: 0.25rem;
		}
	}
}
</style>
